export default "__VITE_ASSET__DpsGwk3$__"